var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socialMediaCardContainer"},[_c('a',{attrs:{"href":_vm.linkData.path,"target":"_blank"}},[_c('div',{staticClass:"socialMediaCard"},[_c('i',{class:_vm.linkData.symbol})])])])}
var staticRenderFns = []

export { render, staticRenderFns }